export enum PageStatus {
  PUBLISH = "publish",
  UNPUBLISH = "unpublish",
}

export type ImageSolutionPageModel = {
  image: string | null;
};

export type SolutionInputModel = {
  id?: string;
  languageId: string;
  title: string;
  status: string;
  isPublish: boolean | null;
  publishDate: string | null;
  description: string | null;
  bannerImage: string | null;
};

export type SolutionOutputModel = {
  id: string;
  languageId: string;
  title: string;
  status: string;
  isPublish: boolean;
  code: string;
  publishDate: string;
  description: string;
  shortDescription: string;
  bannerImage: string;
  categoryId: string;
};
